import { Component } from '@angular/core'

@Component({
  selector: 'se-po-persona-choice-docs',
  templateUrl: './persona-choice-docs.component.html',
  styleUrls: ['./persona-choice-docs.component.scss'],
  standalone: false,
})
export class PersonaChoiceDocsComponent {
  public headers: string[] = [
    'Property',
    'Type',
    'Description',
  ]
  public personaChoiceComponent: any = [
    {
      Property: '@Input() profile',
      Type: 'Households.UserProfile',
      Description: 'Profile rendered as a selectable persona.',
    },
    {
      Property: '@Input() requiredFields',
      Type: 'PersonaRequiredField[]',
      Description: `Optional set of required persona fields. If omitted, DEFAULT_PERSONA_REQUIRED_FIELDS is used.
Allowed values: first_name, last_name, date_of_birth, gender, graduation_year, country, phone, email_address_1,
street_address_1, street_address_2, city, state_province, postal_code.`,
    },
    {
      Property: '@Output() edit',
      Type: 'Households.UserProfile',
      Description: 'Emitted when Edit is clicked for the profile.',
    },
    {
      Property: '@Output() chosen',
      Type: 'Households.UserProfile',
      Description: 'Emitted when the profile is selected.',
    }
  ]
}
